import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'

type Props = {
  onClick: () => void
}

export const CollapseButton = ({
  onClick,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'typo-label1-reading flex items-center gap-0.5 rounded-full bg-black px-3.5 py-2 font-medium text-white',
        'shadow-[0_0_5px_0_rgba(0,0,0,0.48)]',
      )}
    >
      {children}
    </button>
  )
}
